export const ADD_USER_POPUP = 'add_user'; // (ms)
export const ADD_TEAM_POPUP = 'add_team'; // (ms)
export const NO_SELECTION_POPUP = 'no_selection'; // (ms)
export const EDIT_SELECTION_POPUP = 'edit_selection'; // (ms)
export const DELETE_SELECTION_POPUP = 'delete_selection'; // (ms)
